<mbs-modal
  [isCustomModal]="true"
  [title]="'Two-Factor Authentication'"
  [titleTextOverflow]="true"
  [size]="MbsSize.sm">
  <ng-container modal-body>
    @if (actionName(); as actionName) {
      To&nbsp;
      @if (!isVerb()) {
        use&nbsp;
      }
      {{ actionName }}, the <span class="nowrap">Two-Factor</span> Authentication (2FA) must be
      <a
        [routerLink]="[RoutingPath.ApSettings]"
        (click)="handleClose()">
        enabled
      </a>
    } @else {
      <span class="nowrap">Two-Factor</span> Authentication (2FA) must be
      <a
        [routerLink]="[RoutingPath.ApSettings]"
        (click)="handleClose()">
        enabled
      </a>
      to perform this action
    }
  </ng-container>

  <ng-container modalFooter>
    <mbs-button
      data-dismiss="modal"
      [type]="'secondary'"
      (click)="handleClose()">
      {{ 'shared:buttons.close' | i18next: { format: 'title' } }}
    </mbs-button>
  </ng-container>
</mbs-modal>
